
import { component } from '@/helpers/vueTyped';
import { getParentScopedStyleAttrs } from '@/helpers/utils';

interface RailProps {
  categoryName: string;
}

export default component<RailProps>()({
  name: 'Rail',

  functional: true,

  render(h, context) {
    return (
      <div class='rail-container'>
        <div class='category-title'>{context.props.categoryName}</div>
        <div
          ref={context.data.ref}
          on={context.listeners}
          {...{ directives: context.data.directives }}
          attrs={getParentScopedStyleAttrs(context.parent)}
          class={['card-rail', context.data.class]}
        >
          {context.slots().default}
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-e052c960/Rail.vue" });